import { Dialog } from "@kobalte/core/dialog";
import { AnimateChildren } from "@storytell/ui/animation";
import { StButton } from "@storytell/ui/buttons";
import { TbLock, TbX } from "solid-icons/tb";
import { useWire } from "~/wire";

export const InsufficientPermissionsModal = () => {
  const wire = useWire();
  return (
    <AnimateChildren
      show={wire.ui.chatPermissionsGate.isModalOpen()}
      enter={{ opacity: [0, 1], y: [10, 0] }}
      exit={{ opacity: [1, 0], y: [0, 10] }}
    >
      {(anim) => (
        <Dialog
          open={anim.isMounted()}
          onOpenChange={(val) => {
            if (!val) wire.ui.chatPermissionsGate.closeModal();
          }}
        >
          <Dialog.Portal>
            <Dialog.Overlay class="fixed z-90 inset-0 bg-black/50 dark:bg-white/10" />
            <div ref={anim.ref} class="fixed z-90 inset-0 flex items-center justify-center">
              <Dialog.Content class="max-h-[80vh] relative w-screen text-primary-text max-w-xl bg-panel overflow-y-auto rounded-xl p-8">
                <Dialog.CloseButton as={StButton} class="absolute top-4 right-4">
                  <TbX />
                </Dialog.CloseButton>

                <div class="flex items-center gap-3 mb-6">
                  <TbLock class="w-6 h-6 text-muted-text" />
                  <h3 class="text-lg font-medium">Collaborator Access Required</h3>
                </div>

                <p class="mb-4 text-sm text-muted-text">
                  You need collaborator permissions to chat in this project. Please request access from the project
                  owner to continue.
                </p>

                <StButton
                  onClick={() => wire.ui.chatPermissionsGate.closeModal()}
                  class="text-sm max-w-32 ml-auto px-3 py-2 text-on-brand bg-brand hover:bg-brand-hover"
                >
                  Got it
                </StButton>
              </Dialog.Content>
            </div>
          </Dialog.Portal>
        </Dialog>
      )}
    </AnimateChildren>
  );
};
